__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "commercial-grow-ui";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom/client", "18.3.1", function() { return function() { return __webpack_require__(/*! ./.yarn/__virtual__/react-dom-virtual-06fd6c4320/0/cache/react-dom-npm-18.3.1-a805663f38-3f4b73a3aa.zip/node_modules/react-dom/client.js */ "./.yarn/__virtual__/react-dom-virtual-06fd6c4320/0/cache/react-dom-npm-18.3.1-a805663f38-3f4b73a3aa.zip/node_modules/react-dom/client.js"); }; }, 1);
			register("react-dom", "18.3.1", function() { return function() { return __webpack_require__(/*! ./.yarn/__virtual__/react-dom-virtual-06fd6c4320/0/cache/react-dom-npm-18.3.1-a805663f38-3f4b73a3aa.zip/node_modules/react-dom/index.js */ "./.yarn/__virtual__/react-dom-virtual-06fd6c4320/0/cache/react-dom-npm-18.3.1-a805663f38-3f4b73a3aa.zip/node_modules/react-dom/index.js"); }; }, 1);
			register("react-hook-form", "7.43.9", function() { return __webpack_require__.e("vendors-_yarn___virtual___react-hook-form-virtual-d6e88b7f60_0_cache_react-hook-form-npm-7_43-79578d").then(function() { return function() { return __webpack_require__(/*! ./.yarn/__virtual__/react-hook-form-virtual-d6e88b7f60/0/cache/react-hook-form-npm-7.43.9-3a3f4f3335-a83696b7bc.zip/node_modules/react-hook-form/dist/index.esm.mjs */ "./.yarn/__virtual__/react-hook-form-virtual-d6e88b7f60/0/cache/react-hook-form-npm-7.43.9-3a3f4f3335-a83696b7bc.zip/node_modules/react-hook-form/dist/index.esm.mjs"); }; }); });
			register("react/jsx-runtime", "18.3.1", function() { return function() { return __webpack_require__(/*! ./.yarn/cache/react-npm-18.3.1-af38f3c1ae-261137d3f3.zip/node_modules/react/jsx-runtime.js */ "./.yarn/cache/react-npm-18.3.1-af38f3c1ae-261137d3f3.zip/node_modules/react/jsx-runtime.js"); }; }, 1);
			register("react", "18.3.1", function() { return function() { return __webpack_require__(/*! ./.yarn/cache/react-npm-18.3.1-af38f3c1ae-261137d3f3.zip/node_modules/react/index.js */ "./.yarn/cache/react-npm-18.3.1-af38f3c1ae-261137d3f3.zip/node_modules/react/index.js"); }; }, 1);
			initExternal("webpack/container/reference/commercial_payments_ui");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};